import sdkTool from "If_AdTool/common/sdkTool";
//const ADXDOMAIN = process.env.ADXDOMAIN; //"http://10.90.35.52:9090"
let newAdxDomain = "ztyumn.ifeng.com";
let adConfig = {
    ADX_PROTOCOL: process.env.ADXPROTOCOL,
    ADX_DOMAIN: process.env.ADXDOMAIN,
    ADX_PATH: "showcode"
}
if (sdkTool.isMobile()) {
    if (adConfig.ADX_DOMAIN!=""){
        adConfig.ADX_DOMAIN = newAdxDomain;
    }
}else{
}
adConfig.ADX_URL = adConfig.ADX_PROTOCOL + adConfig.ADX_DOMAIN + "/" + adConfig.ADX_PATH;
export default adConfig;